import { render, staticRenderFns } from "./TvProvisioning.vue?vue&type=template&id=2e91c60b&scoped=true&"
import script from "./TvProvisioning.vue?vue&type=script&lang=js&"
export * from "./TvProvisioning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e91c60b",
  null
  
)

export default component.exports